import { useQuery } from '@tanstack/react-query';
import { addDays, endOfDay } from 'date-fns';
import { apiClient } from '@copro/api';
import { DisplayedMeeting } from '../types';

export const nextMeetingKeys = {
  all: ['nextMeeting'] as const,
  detail: (spaceId: string) => [...nextMeetingKeys.all, spaceId] as const,
};

export function useGetNextMeeting(spaceId: string | undefined) {
  return useQuery({
    queryKey: nextMeetingKeys.detail(spaceId || ''),
    queryFn: async () => {
      if (!spaceId) return null;

      const now = new Date();
      // Meetings in the next 15 days
      const maxDate = endOfDay(addDays(now, 14)).toISOString();
      const minDate = now.toISOString();

      const { data, error } = await apiClient
        .from('council_meetings')
        .select('*, documents!meeting_id(id, file_url)')
        .eq('space_id', spaceId)
        .lte('start_time', maxDate)
        .gt('start_time', minDate)
        .order('start_time')
        .limit(1);

      if (error) throw error;

      if (data.length === 0) return null;

      const { documents, ...meeting } = data[0];
      const report = documents?.[0];

      return {
        ...meeting,
        report_url: report?.file_url ?? null,
        report_document_id: report?.id ?? null,
      } as DisplayedMeeting;
    },
    enabled: !!spaceId,
  });
}
